import Nav from "../assets/styles/styled-components/navbar";
import { Link } from "react-router-dom";

const NavBar = () => {
	return (
		<>
			<Nav>
				<div className="nav-link"></div>
				<ul>
					<li>
						<Link to="/">Home</Link>
					</li>
					<li>
						<Link to="/login">Sign Up</Link>
					</li>
					<li>
						<Link to="/careers">View Jobs</Link>
					</li>
					<li>
						<Link to="/jobs">Admin Dashboard</Link>
					</li>
				</ul>
			</Nav>
		</>
	);
};

export default NavBar;
